import { React, useRef } from 'react'
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import "../../../../styles/registrado/cargaDocumento/cargaDocumentos.css"

function CargaDocumentos({user}) {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_jnzpi8n', 'template_1ynxepm', form.current, '2NKWgjMLd0BjG1XVf')
      .then((result) => {
        form.current.reset();
        if (result.text) {
          // Manejar éxito aquí
          Swal.fire({
            icon: 'success',
            title: 'Su solicitud fue procesada con exito.',
            text: '¡Atenderemos su solicitud lo mas pronto posible!',
          });
        } else {
          // Manejar errores aquí
          console.error('Hubo un problema al enviar el mensaje');
        }
      });
  };

  return (
    <>
      <form className="colorful-form" ref={form} onSubmit={sendEmail}>
        <div className="form-group-none">
          <label className="form-label">Nombre de usuario:</label>
          <input 
            required 
            className="form-input form-input-only" 
            name="user_name" 
            value={user.usuarioNombre}
            readOnly
          />
        </div>
        <div className="form-group-none">
          <label className="form-label">Correo de usuario:</label>
          <input 
            required 
            className="form-input form-input-only" 
            name="user_email" 
            value={user.email}
            readOnly
          />
        </div>
        <div className="form-group">
          <label className="form-label">Detalles del documento:</label>
          <textarea 
            required
            placeholder="Especifique qué tipo de documento necesita (sea lo mas claro posible), se lo enviaremos a su correo electronico." 
            className="form-input" 
            name="message" 
            id="message"
            >
          </textarea>
        </div>
        <button className="form-button" type="submit" value="Send">Solicitar documento</button>
      </form>
    </>
  )
}

export default CargaDocumentos
